<template>
  <component class="footer-link" :is="linkElement" v-bind="linkProps">{{ text }}</component>
</template>

<script>
export default {
  name: 'FooterLink',
  props: {
    isSpa: { type: Boolean },
    href: { type: String, required: true },
    text: { type: String, required: true },
  },

  computed: {
    linkElement() {
      return this.isSpa ? 'router-link' : 'a'
    },

    linkProps() {
      return this.isSpa ? { to: this.href } : { href: this.href }
    },
  },
}
</script>
